/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Compaction_FailedInputs */



/**
* | output |
* | --- |
* | "This chat has become too long for the model, and compressing it failed. Try again, or start a new chat if it keeps happening." |
*
* @param {Chat_Error_Compaction_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_compaction_failed = /** @type {((inputs?: Chat_Error_Compaction_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Compaction_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat ist zu lang für das Modell geworden, und die Komprimierung ist fehlgeschlagen. Versuche es erneut oder starte einen neuen Chat, wenn es wiederholt auftritt.")
	return /** @type {LocalizedString} */ ("This chat has become too long for the model, and compressing it failed. Try again, or start a new chat if it keeps happening.")
});